import { addPath } from "./addPath";
import { distanceBetweenPoints } from "./distanceBetweenPoints";
import { getStrokeColorToUse } from "./getStrokeColorToUse";

import { carType, isUserAdmin, isUserSupport, memberCarTrackingLevel } from "constant";
let red = "#FF0000";
//History Polyline

const GPRS_XMIT_STATE_OFFLINE = 3;

// GPS Quality Values
const GPS_QUALITY_AVERAGE_THRESHOLD = 5.0; // 1.0 < quality < 5.0
const betweenPointsThresholdKm = 0.0137;
// Wi-Fi Signal Strength Values
// WiFi Connected/Disconnected constant values
const WIFI_DISCONNECTED = 0.0;

// WiFiSignal Strength
const WIFI_NO_SIGNAL_THRESHOLD = -90;

let NORMAL_CAR_HISTORY_Z_INDEX = 20;
const isPointInsideGeofence = (point, getCarPathActionZone) => {
  let actionZones = getCarPathActionZone?.filter((az) => az.IsGeofence);

  if (!actionZones || actionZones.length === 0) {
    return false;
  }

  return pointInPolygon(
    point,
    actionZones[0].AzVertexes,
    "Longitude",
    "Latitude"
  );
};
const pointInPolygon = (
  point,
  polygon,
  longitudePropertyName,
  latitudePropertyName
) => {
  var x = point[0],
    y = point[1];
  var inside = false;

  for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    var xi = polygon[i][longitudePropertyName],
      yi = polygon[i][latitudePropertyName];
    var xj = polygon[j][longitudePropertyName],
      yj = polygon[j][latitudePropertyName];

    var intersect =
      yi > y !== yj > y &&
      x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
};

export const showSpecifiCarHistory = (
  mapData,
  mapsData,
  memberCarTracking,
  polyLineState,
  setPolyLineState,
  actionZonePoints,
  setActionZonePoints,
  polyRef,
  actionRef,
  specificCarHistoryData,
  historyOptions,
  polyLinesData,
  carHistoryList,
  getUserRole,
  setHoverStateHistory,
  loadingOnProcess,
  specificHistoryClicked,
  getCarPathActionZone,
  getSiteAreasState,
  getHoleAreasState,
  getFeatureSetOption,
  siteSettingsData,
  getFeaturesList
) => {
  if (mapsData) {
    let strokeColor = red;
    let lastStrokeColor = null;
    let infoWindow = mapsData ? new mapsData.InfoWindow() : null;

const isHistoryPointOnCourse = (historyPoint) => {
  const point = historyPoint;
  for (let i = 0; i < getSiteAreasState?.length; i++) {
    if (pointInPolygon(point, getSiteAreasState[i]?.Polygon, "Lon", "Lat")) {
      return true;
    }
  }

  for (let i = 0; i < getHoleAreasState?.length; i++) {
    if (pointInPolygon(point, getHoleAreasState[i]?.Polygon, "Lon", "Lat")) {
      return true;
    }
  }
  return false;
};
    polyLineState.forEach((it) => it.setMap(null));
    actionZonePoints.forEach((zone) =>
      Object.values(zone.markers).forEach((marker) => marker.setMap(null))
    );
    if (polyRef.current) {
      polyRef.current.map((value) => {
        return value.setMap(null);
      });
    }
    if (actionRef.current) {
      actionRef.current.map((zone) => {
        return Object.values(zone.markers).map((marker) => {
          return marker.setMap(null);
        });
      });
    }

    setPolyLineState([]);
    setActionZonePoints([]);
    let actionZonePointsData = [];

    let NumOfSelectedCarsForHistory = specificCarHistoryData
      ? Object.keys(specificCarHistoryData).length
      : 0;

    if (historyOptions === 1 && specificCarHistoryData && NumOfSelectedCarsForHistory !== 0) {
      var numActionZoneMarkersAdded = 0;
      var numPolyLinesAdded = 0;

      Object.values(specificCarHistoryData).forEach((item) => {
        item.forEach((item2, carIndex) => {
          var specificCarLatLong = [];
          item2?.forEach((location) => {
            let latLng = {
              lat: location.Latitude,
              lng: location.Longitude,
            };
            specificCarLatLong.push(latLng);

            if ((NumOfSelectedCarsForHistory === 1) && location.IsActionZonePoint) {
              const circleDiv = document.createElement("div");
              circleDiv.style.width = "6px";
              circleDiv.style.height = "6px";
              circleDiv.style.borderRadius = "50%";
              circleDiv.style.backgroundColor = "#001EFF";
              circleDiv.style.border = "1px solid white";
              circleDiv.style.boxSizing = "border-box";
              circleDiv.style.boxShadow = "0 0 2px rgba(0, 0, 0, 0.3)";
              circleDiv.style.position = "absolute";
              circleDiv.style.transform = "translate(-50%, -50%)";

              // show blue dot for action zone violation (if showing data for a single car)
              let marker =
                mapsData && new mapsData.marker.AdvancedMarkerElement({
                  position: new mapsData.LatLng(
                    location.Latitude,
                    location.Longitude
                  ),
                  map: mapData,
                  content: circleDiv,
                });

              marker.car = location.CarNumber;
              ++numActionZoneMarkersAdded;
              mapsData.event.addListener(marker, "mouseover", function (event) {
                infoWindow.setContent(
                  "<div'>" +
                  "<span style='font-size: 1.5em'>Car: " +
                  `${location.CarNumber.toString()}` +
                  "</span>" +
                  "<br><span>" +
                  `${location.TimeStamp}` +
                  "</span>" +
                  "</div>"
                );
                infoWindow.setPosition(null);
                infoWindow.setZIndex(10);
                infoWindow.open(mapData, marker);
              });

              mapsData.event.addListener(marker, "mouseout", function (event) {
                if (infoWindow) {
                  infoWindow.setContent("");
                  infoWindow.close();
                }
              });
              let markerIndex = actionZonePointsData.findIndex(
                (it) => it.car === location.CarNumber
              );
              if (markerIndex === -1) {
                actionZonePointsData.push({
                  car: location.CarNumber,
                  markers: [marker],
                });
              } else {
                actionZonePointsData[markerIndex].markers.push(marker);
              }
            }
          });

          if (specificCarLatLong.length > 0) {

            const car = item2?.[0];
            const trackingMode = siteSettingsData?.MemberCarTrackingLevel;

            const isMemberCar = car.CarType === carType.member;
            const role = getUserRole?.Role;
            const isAdminOrSupport = isUserAdmin(role) || isUserSupport(role);
            const hasFeatureAccess = !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars);
            if (isMemberCar && !isAdminOrSupport && !hasFeatureAccess) return;
            if (isMemberCar && !isAdminOrSupport && hasFeatureAccess) {
              switch (trackingMode) {
                case memberCarTrackingLevel.Never:
                  return;
                case memberCarTrackingLevel.InsideGeoFence:
                  specificCarLatLong = specificCarLatLong.filter((latLng) => {
                    const point = [latLng.lng, latLng.lat];
                    return isPointInsideGeofence(point, getCarPathActionZone);
                  });
                  if (specificCarLatLong.length === 0) return;
                  break;
                case memberCarTrackingLevel.OnCourseOrPlayingGolf:
                  if (car?.HolesPlayed && car.HolesPlayed !== 0) break;
                  specificCarLatLong = specificCarLatLong.filter((latLng) => {
                    const historyPoint = [latLng.lng,latLng.lat];
                    return isHistoryPointOnCourse(historyPoint);
                  });
                  if (specificCarLatLong.length === 0) return;
                  break;
                case memberCarTrackingLevel.Always:
                default:
                  break;
              }
            }
            if (specificCarLatLong.length === 0) return;
            // add polyline to map
            var flightPath =
              mapsData &&
              new mapsData.Polyline({
                path: specificCarLatLong,
                strokeColor: "#FFFF00",
                strokeOpacity: 1,
                strokeWeight: NumOfSelectedCarsForHistory > 1 ? 2 : 4,
                zIndex: NORMAL_CAR_HISTORY_Z_INDEX,
              });
            if (flightPath) {
              ++numPolyLinesAdded;
              flightPath.setMap(mapData);
              flightPath.car = item2?.[0]?.CarNumber;
              flightPath.index = carIndex;
              polyLinesData.push(flightPath);
            }

            if (NumOfSelectedCarsForHistory > 1) {
              mapsData.event.addListener(
                flightPath,
                "click",
                function () {
                  polyLinesData.forEach((it) => {
                    if (it.car !== flightPath.car) it.setMap(null);
                  });
                  carHistoryList.set([flightPath.car]);
                  polyLinesData = polyLinesData.filter(
                    (it) => it.car === flightPath.car
                  );
                  polyLinesData.forEach((hop) => {
                    hop?.setOptions({
                      strokeColor: "yellow",
                      strokeWeight: 4,
                      zIndex: "#FF0000",
                    });
                  });
                  setPolyLineState(polyLinesData);

                  specificHistoryClicked.set(true);
                }
              );
            }

            mapsData.event.addListener(
              flightPath,
              "mouseover",
              function (event) {
                if (
                  NumOfSelectedCarsForHistory &&
                  NumOfSelectedCarsForHistory > 1
                ) {
                  let hoveredOverPaths = polyLinesData.filter(
                    (it) => it.car === flightPath.car
                  );
                  hoveredOverPaths.forEach((hop) => {
                    hop?.setOptions({
                      strokeColor: "#001EFF",
                      strokeWeight: 4,
                      zIndex: "#001EFF",
                    });
                  });
                }
                let paths = flightPath.getPath().getArray();
                let locationIndex = 0;
                let distance = 100; // 100 KM
                let hoveredOverIndex = 0;
                paths.forEach(function (location) {
                  let newDistance = distanceBetweenPoints(
                    location,
                    event.latLng
                  );
                  if (newDistance < distance) {
                    distance = newDistance;
                    hoveredOverIndex = locationIndex;
                  }
                  locationIndex += 1;
                });
                let he = item[flightPath.index][hoveredOverIndex]; // item element
                if (he) {
                  infoWindow.setContent(
                    "<div'>" +
                    "<span style='font-size: 1.5em'>Car: " +
                    `${he.CarNumber.toString()}` +
                    "</span>" +
                    "<br><span>" +
                    `${he.TimeStamp}` +
                    "</span>" +
                    "</div>"
                  );
                  infoWindow.setPosition(
                    new mapsData.LatLng(he.Latitude, he.Longitude)
                  );
                  infoWindow.open(mapData, flightPath);
                }
              }
            );

            mapsData.event.addListener(
              flightPath,
              "mousemove",
              function (event) {
                let paths = flightPath.getPath().getArray();
                let locationIndex = 0;
                let distance = 100; // 100 KM
                let hoveredOverIndex = 0;
                paths.forEach(function (path) {
                  let newDistance = distanceBetweenPoints(path, event.latLng);
                  if (newDistance < distance) {
                    distance = newDistance;
                    hoveredOverIndex = locationIndex;
                  }
                  locationIndex += 1;
                });
                let he = item[flightPath.index][hoveredOverIndex];
                if (he) {
                  infoWindow.setContent(
                    "<div'>" +
                    "<span style='font-size: 1.5em'>Car: " +
                    `${he.CarNumber.toString()}` +
                    "</span>" +
                    "<br><span>" +
                    `${he.TimeStamp}` +
                    "</span>" +
                    "</div>"
                  );
                  infoWindow.setPosition(
                    new mapsData.LatLng(he.Latitude, he.Longitude)
                  );
                  infoWindow.open(mapData, flightPath);
                }
              }
            );

            mapsData.event.addListener(
              flightPath,
              "mouseout",
              function (event) {
                if (
                  NumOfSelectedCarsForHistory &&
                  NumOfSelectedCarsForHistory > 1
                ) {
                  let hoveredOverPaths = polyLinesData.filter(
                    (it) => it.car === flightPath.car
                  );
                  hoveredOverPaths.forEach((hop) => {
                    hop?.setOptions({
                      strokeColor: "yellow",
                      strokeWeight: 4,
                      zIndex: "#FF0000",
                    });
                  });
                }
                if (infoWindow) infoWindow.close();
              }
            );
          }

        });
      });
      polyRef.current = polyLinesData;
      actionRef.current = actionZonePointsData;
      setPolyLineState(polyLinesData);
      setActionZonePoints(actionZonePointsData);
      loadingOnProcess.set(false);
    } else if (
      specificCarHistoryData &&
      NumOfSelectedCarsForHistory !== 0 &&
      getUserRole &&
      (isUserAdmin(getUserRole?.Role) || isUserSupport(getUserRole?.Role))
    ) {
      //1 is admin role and 3 is support admin
      Object.values(specificCarHistoryData).forEach((item) => {
        item.forEach((item2, carIndex) => {
          var specificCarLatLong = [];
          var lastLatLng = null;
          item2?.forEach((location) => {
            if (
              (historyOptions === 2 &&
                location.GprsXmitState === GPRS_XMIT_STATE_OFFLINE) ||
              (historyOptions === 3 &&
                location.GpsQuality < GPS_QUALITY_AVERAGE_THRESHOLD) ||
              (historyOptions === 4 &&
                location.WiFiSignalStrength > WIFI_NO_SIGNAL_THRESHOLD &&
                location.WiFiSignalStrength < WIFI_DISCONNECTED)
            ) {
              let latlan = new mapsData.LatLng(
                location.Latitude,
                location.Longitude
              );
              latlan.TimeStamp = location.TimeStamp;
              strokeColor = getStrokeColorToUse(historyOptions, location);
              if (
                (!lastLatLng ||
                  distanceBetweenPoints(latlan, lastLatLng) <
                  betweenPointsThresholdKm) &&
                (lastStrokeColor === null || strokeColor === lastStrokeColor)
              ) {
                specificCarLatLong.push(latlan);
              } else {
                // When the distance between points exceeds the threshold distance metric being tracked
                // needs to be shown in a different color.  This means we
                // need to add the current path being constructed and then start a new path.
                // Make sure we use lastStrokeColor here since either it is the same as
                // strokeColor and we are starting a new path due to distance between points,
                // or it is not equal and that is the reason we are starting a new path.  In this latter
                // case we need to use the lastStrokColor as that is the stroke color for the constructed path
                // that we are about to add.
                addPath(
                  specificCarLatLong,
                  lastStrokeColor,
                  item,
                  carIndex,
                  mapData,
                  mapsData,
                  specificCarHistoryData,
                  historyOptions,
                  polyLinesData,
                  setHoverStateHistory,
                  polyLinesData,
                  setPolyLineState,
                  carHistoryList
                );
                specificCarLatLong = [];
                // Add the coordinate that is going to start the next path back in otherwise we will lose it.
                specificCarLatLong.push(latlan);
              }
              lastStrokeColor = strokeColor;
              lastLatLng = latlan;
            }
          });
          addPath(
            specificCarLatLong,
            strokeColor,
            item,
            carIndex,
            mapData,
            mapsData,
            specificCarHistoryData,
            historyOptions,
            polyLinesData,
            setHoverStateHistory,
            polyLinesData,
            setPolyLineState,
            carHistoryList
          );
        });
      });
      setPolyLineState(polyLinesData);
      setActionZonePoints(actionZonePointsData);
      loadingOnProcess.set(false);
    } else {
      loadingOnProcess.set(false);
    }
  }
};
